import {logger} from '../../../../../libs/shared/core/src/services/logger/logger';

const workspaceDragAndDropLogger = logger.getLogger('workspace-drag-and-drop');

enum WorkspaceDragAndDropPerformanceMarksEnum {
  START = 'useWorkspaceDragAndDropStart',
  END = 'useWorksapceDragAndDropEnd',
  DURATION = 'useWorkspaceDragAndDropDuration',
}

let isCollectingMetrics = true;

export function markWorkspaceDragAndDropStart() {
  if (!isCollectingMetrics) {
    return;
  }
  performance.mark(WorkspaceDragAndDropPerformanceMarksEnum.START);
}

export function markWorkspaceDragAndDropEnd() {
  if (!isCollectingMetrics) {
    return;
  }
  performance.mark(WorkspaceDragAndDropPerformanceMarksEnum.END);
  performance.measure(
    WorkspaceDragAndDropPerformanceMarksEnum.DURATION,
    WorkspaceDragAndDropPerformanceMarksEnum.START,
    WorkspaceDragAndDropPerformanceMarksEnum.END,
  );
}

function aggregateWorkspaceDragAndDropTimings() {
  const entries = performance.getEntriesByName(WorkspaceDragAndDropPerformanceMarksEnum.DURATION);
  const totalTime = entries.map(({duration}) => duration).reduce((sum, duration) => sum + duration, 0);
  return {
    duration: totalTime,
    count: entries.length,
  };
}

export function reportWorkspaceDragAndDropPerformanceMetrics() {
  const {count, duration} = aggregateWorkspaceDragAndDropTimings();
  workspaceDragAndDropLogger.info('Workspace Drag and Drop Performance', {
    duration,
    count,
  });

  isCollectingMetrics = false;

  performance.clearMarks(WorkspaceDragAndDropPerformanceMarksEnum.START);
  performance.clearMarks(WorkspaceDragAndDropPerformanceMarksEnum.END);
  performance.clearMeasures(WorkspaceDragAndDropPerformanceMarksEnum.DURATION);
}
